import React, { PropsWithChildren, useEffect, useState } from 'react';

import { WrappedLoader } from '../components/ui/Loader';
import { useAppDispatch } from '../utils/store/hooks';
import { verifyTokenAsyncAction } from '../utils/store/slices/user.slice';

interface Props extends PropsWithChildren { }

const AuthProvider: React.FC<Props> = ({ children }) => {
    const dispatch = useAppDispatch();

    const [isAuthenticating, setIsAuthenticating] = useState(true)

    // Using cookies
    useEffect(() => {
        setIsAuthenticating(true)
        const timerId = setTimeout(() => {
            dispatch(verifyTokenAsyncAction())
                .finally(() => {
                    setIsAuthenticating(false)
                })
        }, 0);

        return () => {
            clearTimeout(timerId)
        }
    }, [])

    // Using localstorage
    // useEffect(() => {
    //     const timerId = setTimeout(() => {
    //         const authToken = localStorage.getItem(STORAGE_AUTH_TOKEN_KEY)
    //         if (authToken) {
    //             api.defaults.headers.common['Authorization'] = `Bearer ${authToken}`
    //             dispatch(verifyTokenAsyncAction())
    //                 .then((data) => {
    //                     if (data.meta.requestStatus === 'fulfilled') {
    //                         const authToken = (data.payload as IAuthResponse).token;

    //                         if (authToken) {
    //                             api.defaults.headers.common['Authorization'] = `Bearer ${authToken}`
    //                             localStorage.setItem(STORAGE_AUTH_TOKEN_KEY, authToken)
    //                         }
    //                     }
    //                     else {
    //                         localStorage.removeItem(STORAGE_AUTH_TOKEN_KEY)
    //                         api.defaults.headers.common['Authorization'] = 'Bearer '
    //                     }
    //                 })
    //                 .finally(() => {
    //                     setIsAuthenticating(false)
    //                 })
    //         }
    //         else {
    //             setIsAuthenticating(false)
    //         }
    //     }, 0);

    //     return () => {
    //         clearTimeout(timerId)
    //     }
    // }, [])

    if (isAuthenticating) {
        return (
            <WrappedLoader />
        )
    }

    return children
}

export default AuthProvider